

// import React, { useEffect, useState } from 'react';
// import { Download, Smartphone, X, ShieldCheck } from 'lucide-react';

// const Downloadbutton = () => {
//   const [supportsPWA, setSupportsPWA] = useState(false);
//   const [promptInstall, setPromptInstall] = useState(null);
//   const [isDismissed, setIsDismissed] = useState(false);

//   useEffect(() => {
//     const handler = (e) => {
//       e.preventDefault();
//       console.log('PWA prompt triggered');
//       setSupportsPWA(true);
//       setPromptInstall(e);
//     };

//     window.addEventListener('beforeinstallprompt', handler);

//     return () => window.removeEventListener('beforeinstallprompt', handler);
//   }, []);

//   const onClick = (evt) => {
//     evt.preventDefault();
//     if (!promptInstall) return;

//     promptInstall.prompt();
//     promptInstall.userChoice.then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         setSupportsPWA(false);
//       }
//     });
//   };

//   if (!supportsPWA || isDismissed) {
//     return null;
//   }

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@600;700;800&display=swap');

//         .pwa-sticky-bar-wrapper {
//           position: fixed;
//           /* Adjusted bottom value to sit nicely above the navigation/footer */
//           bottom: 100px;
//           /* Absolute horizontal centering */
//           left: 50%;
//           transform: translateX(-50%);
//           /* Width constraints to ensure it doesn't touch the very edges of mobile screens */
//           width: calc(100% - 32px);
//           max-width: 420px;
//           margin: 0 auto;
//           z-index: 9990;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           pointer-events: auto;
//           animation: slideUpFloat 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
//         }

//         .pwa-glass-card {
//           position: relative;
//           background: rgba(15, 23, 42, 0.92);
//           backdrop-filter: blur(20px);
//           -webkit-backdrop-filter: blur(20px);
//           border: 1px solid rgba(255, 255, 255, 0.96);
//           border-radius: 20px;
//           padding: 12px 16px;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6),
//                       inset 0 1px 0 rgba(255, 255, 255, 0.2);
//           overflow: hidden;
//         }

//         .pwa-glass-card::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           left: -20%;
//           width: 80%;
//           height: 200%;
//           background: radial-gradient(circle, rgba(16, 185, 129, 0.15) 0%, rgba(0, 0, 0, 0) 70%);
//           pointer-events: none;
//         }

//         .pwa-left-content {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           z-index: 2;
//         }

//         .pwa-icon-box {
//           width: 44px;
//           height: 44px;
//           border-radius: 12px;
//           background: linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(5, 150, 105, 0.1) 100%);
//           border: 1px solid rgba(16, 185, 129, 0.3);
//           color: #34d399;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//           box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
//         }

//         .pwa-text-group {
//           display: flex;
//           flex-direction: column;
//         }

//         .pwa-app-title {
//           color: #f8fafc;
//           font-size: 0.85rem;
//           font-weight: 800;
//           line-height: 1.2;
//           letter-spacing: -0.01em;
//         }

//         .pwa-app-subtitle {
//           color: #10b981;
//           font-size: 0.7rem;
//           font-weight: 700;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//           margin-top: 2px;
//         }

//         .pwa-right-actions {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           z-index: 2;
//         }

//         .pwa-install-btn {
//           position: relative;
//           background: linear-gradient(135deg, #10b981 0%, #059669 100%);
//           color: #ffffff;
//           border: none;
//           outline: none;
//           padding: 8px 16px;
//           border-radius: 12px;
//           font-size: 0.8rem;
//           font-weight: 800;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 6px;
//           box-shadow: 0 4px 14px rgba(16, 185, 129, 0.4);
//           transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
//           overflow: hidden;
//           animation: pulseGlow 2s infinite ease-in-out;
//         }

//         .pwa-install-btn:hover {
//           transform: translateY(-1px) scale(1.02);
//           box-shadow: 0 6px 18px rgba(16, 185, 129, 0.55);
//         }

//         .pwa-install-btn:active {
//           transform: translateY(0) scale(0.96);
//         }

//         .shimmer-line {
//           position: absolute;
//           top: 0;
//           left: -100%;
//           width: 50%;
//           height: 100%;
//           background: linear-gradient(
//             90deg,
//             transparent,
//             rgba(255, 255, 255, 0.35),
//             transparent
//           );
//           transform: skewX(-20deg);
//           animation: shimmerPass 2.8s infinite;
//         }

//         .pwa-close-btn {
//           background: rgba(255, 255, 255, 0.05);
//           border: 1px solid rgba(255, 255, 255, 0.91);
//           color: #64748b;
//           width: 32px;
//           height: 32px;
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: all 0.2s ease;
//         }

//         .pwa-close-btn:hover {
//           background: rgba(255, 255, 255, 0.15);
//           color: #f8fafc;
//         }

//         @keyframes slideUpFloat {
//           0% {
//             opacity: 0;
//             transform: translate(-50%, 30px);
//           }
//           100% {
//             opacity: 1;
//             transform: translate(-50%, 0);
//           }
//         }

//         @keyframes pulseGlow {
//           0% {
//             box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5);
//           }
//           70% {
//             box-shadow: 0 0 0 10px rgba(16, 185, 129, 0);
//           }
//           100% {
//             box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
//           }
//         }

//         @keyframes shimmerPass {
//           0% { left: -100%; }
//           30% { left: 200%; }
//           100% { left: 200%; }
//         }
//       `}</style>

//       <div className="pwa-sticky-bar-wrapper">
//         <div className="pwa-glass-card">
          
//           <div className="pwa-left-content">
//             <div className="pwa-icon-box">
//               <Smartphone size={22} />
//             </div>
//             <div className="pwa-text-group">
//               <span className="pwa-app-title">KRLUDO Official App</span>
//               <span className="pwa-app-subtitle">
//                 <ShieldCheck size={12} /> Fast & Secure APK
//               </span>
//             </div>
//           </div>

//           <div className="pwa-right-actions">
//             <button className="pwa-install-btn" onClick={onClick}>
//               <span className="shimmer-line"></span>
//               <Download size={15} />
//               <span>INSTALL</span>
//             </button>

//             <button
//               className="pwa-close-btn"
//               onClick={() => setIsDismissed(true)}
//               aria-label="Dismiss banner"
//             >
//               <X size={16} />
//             </button>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// };

// export default Downloadbutton;


import React, { useEffect, useState } from 'react';
import { Download, Smartphone, X, ShieldCheck, Sparkles, CheckCircle2 } from 'lucide-react';

const Downloadbutton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log('PWA prompt triggered');
      setSupportsPWA(true);
      setPromptInstall(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) return;

    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        setSupportsPWA(false);
      }
    });
  };

  if (!supportsPWA || isDismissed) {
    return null;
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@600;700;800&family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap');

        /* Backdrop Layer for Center Focus */
        .ce-center-pwa-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(3, 5, 10, 0.75);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          z-index: 99999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
          box-sizing: border-box;
          animation: ceFadeIn 0.3s ease-out forwards;
        }

        /* Center Floating Card */
        .ce-center-pwa-card {
          position: relative;
          width: 100%;
          max-width: 360px;
          background: linear-gradient(180deg, rgba(15, 23, 42, 0.98) 0%, rgba(7, 10, 15, 0.99) 100%);
          border: 1px solid rgba(16, 185, 129, 0.4);
          border-radius: 28px;
          padding: 26px 20px 22px 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          box-shadow: 
            0 25px 60px rgba(0, 0, 0, 0.9),
            0 0 40px rgba(16, 185, 129, 0.25),
            inset 0 1px 0 rgba(255, 255, 255, 0.15);
          font-family: 'Plus Jakarta Sans', sans-serif;
          color: #ffffff;
          overflow: hidden;
          animation: ceElasticPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }

        /* Top Radiant Radial Aura */
        .ce-center-pwa-card::before {
          content: '';
          position: absolute;
          top: -25%;
          left: 50%;
          transform: translateX(-50%);
          width: 200px;
          height: 200px;
          background: radial-gradient(circle, rgba(16, 185, 129, 0.25) 0%, rgba(0, 0, 0, 0) 70%);
          pointer-events: none;
        }

        /* Close Button in Top-Right Corner */
        .ce-pwa-close-btn {
          position: absolute;
          top: 14px;
          right: 14px;
          background: rgba(30, 41, 59, 0.6);
          border: 1px solid rgba(56, 189, 248, 0.25);
          color: #94a3b8;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          z-index: 10;
        }

        .ce-pwa-close-btn:hover {
          background: rgba(244, 63, 94, 0.2);
          border-color: rgba(244, 63, 94, 0.4);
          color: #f43f5e;
          transform: scale(1.08);
        }

        /* Icon Container & Pulse Ring */
        .ce-pwa-icon-wrapper {
          position: relative;
          margin-bottom: 16px;
        }

        .ce-icon-pulse-ring {
          position: absolute;
          inset: -6px;
          border-radius: 22px;
          background: rgba(16, 185, 129, 0.25);
          filter: blur(8px);
          animation: ceRingGlow 2s infinite ease-in-out;
        }

        .ce-pwa-icon-box {
          position: relative;
          width: 64px;
          height: 64px;
          border-radius: 20px;
          background: linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(2, 132, 199, 0.15) 100%);
          border: 1px solid rgba(16, 185, 129, 0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.3);
        }

        .ce-emerald-icon {
          color: #38bdf8;
          filter: drop-shadow(0 0 8px rgba(56, 189, 248, 0.6));
        }

        /* Typography & Badges */
        .ce-pwa-badge-pill {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: rgba(16, 185, 129, 0.15);
          border: 1px solid rgba(16, 185, 129, 0.35);
          border-radius: 20px;
          padding: 3px 10px;
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 0.8px;
          color: #34d399;
          margin-bottom: 8px;
          text-transform: uppercase;
        }

        .ce-pwa-app-title {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 20px;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 6px 0;
          letter-spacing: 0.3px;
        }

        .ce-pwa-app-subtitle {
          font-size: 12.5px;
          color: #94a3b8;
          line-height: 1.45;
          margin: 0 0 16px 0;
        }

        /* Features Bullet Box */
        .ce-pwa-features-box {
          width: 100%;
          background: rgba(5, 8, 14, 0.7);
          border: 1px solid rgba(56, 189, 248, 0.2);
          border-radius: 16px;
          padding: 12px 14px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-bottom: 20px;
          text-align: left;
        }

        .ce-feature-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          color: #e2e8f0;
          font-weight: 600;
        }

        /* Main Install Action Button */
        .ce-pwa-install-btn {
          position: relative;
          width: 100%;
          height: 48px;
          background: linear-gradient(135deg, #10b981 0%, #0284c7 100%);
          color: #ffffff;
          border: none;
          outline: none;
          border-radius: 24px;
          font-family: 'Space Grotesk', sans-serif;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.5px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
          transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
          overflow: hidden;
        }

        .ce-pwa-install-btn:hover {
          filter: brightness(1.1);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.55);
        }

        .ce-pwa-install-btn:active {
          transform: translateY(0) scale(0.97);
        }

        .ce-shimmer-line {
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
          );
          transform: skewX(-20deg);
          animation: ceShimmerPass 2.5s infinite;
        }

        /* Animations */
        @keyframes ceFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes ceElasticPop {
          0% {
            opacity: 0;
            transform: scale(0.8) translateY(20px);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes ceRingGlow {
          0% { opacity: 0.4; transform: scale(0.95); }
          50% { opacity: 0.8; transform: scale(1.05); }
          100% { opacity: 0.4; transform: scale(0.95); }
        }

        @keyframes ceShimmerPass {
          0% { left: -100%; }
          35% { left: 200%; }
          100% { left: 200%; }
        }
      `}</style>

      <div className="ce-center-pwa-backdrop" onClick={() => setIsDismissed(true)}>
        <div 
          className="ce-center-pwa-card" 
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            className="ce-pwa-close-btn"
            onClick={() => setIsDismissed(true)}
            aria-label="Dismiss banner"
          >
            <X size={18} />
          </button>

          {/* Icon Box with Ambient Glow */}
          <div className="ce-pwa-icon-wrapper">
            <div className="ce-icon-pulse-ring"></div>
            <div className="ce-pwa-icon-box">
              <Smartphone size={32} className="ce-emerald-icon" />
            </div>
          </div>

          {/* Heading Section */}
          <div className="ce-pwa-badge-pill">
            <Sparkles size={11} />
            <span>OFFICIAL APP</span>
          </div>

          <h2 className="ce-pwa-app-title">KRLUDO Official App</h2>
          <p className="ce-pwa-app-subtitle">
            Fast, secure & light app experience with instant match notifications.
          </p>
  {/* Action Button */}
          <button className="ce-pwa-install-btn" onClick={onClick}>
            <span className="ce-shimmer-line"></span>
            <Download size={18} />
            <span>INSTALL APP NOW</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Downloadbutton;